// 读取后台WEB规则数组，兼容历史富文本，错误配置不能显示成空规则。
export function readVipActivityRules(value) {
  if (value == null || String(value).trim() === '' || value === 'null') return []
  let rows = value
  if (typeof value === 'string') {
    const content = value.trim()
    if (!content.startsWith('[') && !content.startsWith('{')) return [{ content, sortNo: 1 }]
    rows = JSON.parse(content)
  }
  if (!Array.isArray(rows) || rows.some(row => !row || typeof row.content !== 'string' || !row.content.trim() || !Number.isInteger(Number(row.sortNo)) || Number(row.sortNo) < 1)) {
    throw new Error('VIP活动规则格式错误，请联系客服')
  }
  return rows.map(row => ({ content: row.content.trim(), sortNo: Number(row.sortNo) })).sort((a, b) => a.sortNo - b.sortNo)
}
